<script lang="ts">
    import type {AxiosInstance} from 'axios';
    import {fade, fly} from 'svelte/transition';

    import {dyData} from 'general/store';
    import {TEMPLATE} from 'general/constants';

    import Description from './description/Description.svelte';
    import Form from 'general/components/form/sms/Form.svelte';

    import s from './style.module.css';
    import Brands from 'desktop/templates/squareCommonModal/components/brands/Brands.svelte';

    export let instance: AxiosInstance;
</script>

<div
    in:fade={{duration: 400}}
    out:fade={{duration: 400}}
    class={s.main}
    style="margin-top: {$dyData.side.sms?.marginTop || 0}"
>
    {#if Array.isArray($dyData.side.sms.image)}
        <div class={s.imagesWrapper}>
            {#each $dyData.side.sms.image as image}
                <div class={s.imagesItem}>
                    <img class={s.images} src={image} alt={$dyData.side.sms.alt} />
                </div>
                {#if $dyData.hasBrands}
                    <Brands />
                {/if}
            {/each}
        </div>
    {:else}
        <div
            class={s.imageContainer}
            class:bigImageContainer={$dyData.side.sms.isBigImage}
            class:smallScreen={$dyData.isSmallerScreen}
        >
            <img
                class={s.image}
                class:shrinkImage={$dyData.isSmallerScreen}
                src={$dyData.side.sms.image}
                alt={$dyData.side.sms.alt}
            />
            {#if $dyData.hasBrands}
                <Brands />
            {/if}
        </div>
    {/if}
    <div in:fly={{y: 400, duration: 500}}>
        <Description value={$dyData.description?.sms} isSmallerScreen={$dyData.isSmallerScreen} />

        <Form {instance} template={TEMPLATE.SQUARE_DESKTOP_COMMON} />
    </div>
</div>
